import { IFilterDate, IOnInit } from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../records/server/serverUtility";
import { Machine } from "../../../../models/machine";
import { MachineConfiguration } from "../../../../models/machineConfiguration";
import {
  MachineConfigurationProgressiveInformation,
  MachineConfigurationProgressiveMap,
  ProgressiveDefinition,
} from "../../../../models/progressiveDefinition";

export class MachineDetailProgressiveConfigurationComponentController
  implements IOnInit
{
  private readonly date: Date;

  static $inject = ["environment", "dateFilter", ServerUtilityName];
  constructor(
    environment: { Date: Date },
    private readonly dateFilter: IFilterDate,
    readonly serverUtility: ServerUtility
  ) {
    this.date = environment.Date;
  }

  readonly machine!: Machine;
  configurations: MachineConfiguration[] = [];
  readonly progressiveInformation: MachineConfigurationProgressiveMap = {};

  $onInit(): void {
    this.configurations = this.machine.Configs ?? [];
  }

  progressiveSelected(
    machineConfiguration: MachineConfiguration,
    progressive: ProgressiveDefinition
  ) {
    const machineConfigurationId = machineConfiguration.Id;

    this.serverUtility
      .sendApiRequest<MachineConfiguration>({
        url: `/api/machines/MachineConfiguration/${machineConfigurationId}/ProgressiveDefinitionId`,
        method: "PUT",
        data: {
          ProgressiveDefinitionId: progressive?.Id,
        },
      })
      .then((r: any) => {
        const url = `/api/machines/MachineConfiguration/${r.Result.Id}/progressiveInformation`;
        return this.serverUtility.sendApiRequest<MachineConfigurationProgressiveInformation>(
          {
            url,
            method: "POST",
          }
        );
      })
      .then((result: any) => {
        const pi = result.Result;
        this.progressiveInformation[pi.MachineConfigurationId] = pi;
      });
  }

  getAccordionHeading(configuration: MachineConfiguration) {
    const configurationDate: Date = configuration.Date!;
    const systemDate: Date = this.date;
    const currentConfiguration: boolean =
      configuration.CurrentConfiguration ?? false;

    const futureChange = configurationDate > systemDate;
    const changeTypeDetail = configuration.ConversionTypeName
      ? `(${configuration.ConversionTypeName})`
      : "";

    return `${configuration.ChangeType}${changeTypeDetail} - ${this.dateFilter(
      configurationDate
    )}${currentConfiguration && !futureChange ? " - Current" : ""}${
      futureChange ? " - Pending" : ""
    }`;
  }

  getProgressiveDefinitionGetterSetter(configuration: MachineConfiguration) {
    return ((value: ProgressiveDefinition) => {
      const progressiveInfo = this.progressiveInformation[configuration.Id];
      if (value === undefined) {
        return progressiveInfo?.ProgressiveDefinition;
      }
      if (progressiveInfo !== undefined) {
        progressiveInfo.ProgressiveDefinition = value;
      }
    }).bind(this);
  }

  private progressiveDefinitionQueryResults: ProgressiveDefinition[] = [];
  queryProgressiveDefinitions(select: any) {
    this.serverUtility
      .lookupQuery({
        search: select.search,
        url: "/api/machines/progressives/ProgressiveDefinition",
      })
      .then((result) => {
        const queryResults = <ProgressiveDefinition[]>result.Results;
        this.progressiveDefinitionQueryResults = queryResults;
      });
  }
}
